module.exports = __webpack_public_path__ + "static/media/fichas.815f54ee.jpg";